import {EmulatorMessage, EmulatorMessageTypes} from '../../../../../shared/models/emulator';
import {Injectable} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';

export interface MediaMetaData {
  name: string;
  src: string;
  size: string;
  type: string;
  caption: string;
}

@Injectable({
  providedIn: 'root',
})
export class ChatBubbleService {

  private URL_REGEX: RegExp = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gm;

  constructor(private sanitizer: DomSanitizer) {}
  isFirstURl = false;
  isCheckURl = false;
  otherUrls: string[] = [];

  public isUserMessage(emulatorMessage: EmulatorMessage) {
    return (
      emulatorMessage.messageType === EmulatorMessageTypes.MESSAGE_REPLY ||
      emulatorMessage.messageType === EmulatorMessageTypes.START
    );
  }

  public urlCheck(message): String {
    if (message) {
      const replacer = (match) => `<a href="${match}" target="_blank">${match} </a>`;
      return message.replace(this.URL_REGEX, replacer);
    }
  }

  urlPreview(message): {mainUrl: string, rootUrl: any, remainder: string } {
    this.otherUrls = [];
    let content;
    if (message) {

      if (isNaN(message)) {
        this.isFirstURl = true;
        const matches = message.match(this.URL_REGEX);

        if (matches) {
          this.isCheckURl = true;
          if (this.isFirstURl) {
            content = {
              mainUrl: matches[0].includes('http') ? matches[0] : 'https://'+matches[0],
              rootUrl: this.getRootUrl(matches[0]),
              remainder: this.urlCheck(message.replace(matches[0], ''))
            };
          }
        } else {
          content = this.setStandardMessageOutput(message);
        }
      }

      if (!isNaN(message)) {
        content = this.setStandardMessageOutput(message);
      }

    }
    return content;
  }

  private setStandardMessageOutput(message) {
    this.isCheckURl = false;
    return {
      mainUrl: null,
      rootUrl: null,
      remainder: message
    };
  }

  getIsCheckUrl() {
    return this.isCheckURl;
  }

  getRootUrl(url) {
    let rootUrl = url;
    if (!rootUrl.startsWith('http://') && !rootUrl.startsWith('https://')) {
      rootUrl = `http://${rootUrl}`;
    }
    const urlmessage = new URL(rootUrl);
    rootUrl = urlmessage.origin;
    if (rootUrl.startsWith('https://')) {
      rootUrl = rootUrl.substring(8);
    } else if (rootUrl.startsWith('http://')) {
      rootUrl = rootUrl.substring(7);
    }
    return rootUrl;
  }
}
